import type { ComponentClass } from 'react';
import { withAnalyticsContext } from '@atlaskit/analytics-next';
import AkModalDialog from '@atlaskit/modal-dialog';

export default (name: string, Component: ComponentClass<any>) =>
	withAnalyticsContext({ componentName: name })(Component || AkModalDialog);
